<!-- confirmation-dialog.component.html -->
<div class="p-4">
  <h2 mat-dialog-title *ngIf="data.title">{{ data.title }}</h2>
  <div mat-dialog-content *ngIf="data.message" class="text-center mb-3">{{ data.message }}</div>
  <div mat-dialog-actions class="justify-content-center">
    <button mat-button class="fdx-c-button fdx-c-button--text fxg-margin-right" (click)="onCancelClick()">Cancel</button>
    <button mat-button class="fdx-c-button fdx-c-button--primary fxg-margin-right" (click)="onConfirmClick()" cdkFocusInitial>Confirm</button>
  </div>
</div>